@if (wiki) {
  <a [class]="aClass" [href]="wiki.href || '#'" [attr.target]="openNewTab ? '_blank' : undefined" [style.order]="order">
    <mat-icon>open_in_new</mat-icon>
    <span>{{label()}}</span>
  </a>
}
